"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import NextLink from "next/link";
import { Link as LinkDef } from "../../../controls/link";
import { useIsPagesRouter } from "../../../next/hooks/use-is-pages-router";
import { useResolvedValue } from "../../../runtimes/react/hooks/use-resolved-value";
const isValidHref = (href) => {
  try {
    const bases = ["http://n", "https://n"];
    bases.forEach((base) => new URL(href, base));
  } catch (_) {
    return false;
  }
  return true;
};
const Link = forwardRef(function Link2({ link, onClick = () => {
}, ...restOfProps }, ref) {
  const {
    href,
    target,
    onClick: resolvedOnClick
  } = useResolvedValue(
    link,
    (link2, resourceResolver) => LinkDef().resolveValue(link2, resourceResolver)
  ) ?? {};
  function handleClick(event) {
    onClick(event);
    if (event.defaultPrevented)
      return;
    if (event.currentTarget.isContentEditable)
      return event.preventDefault();
    return resolvedOnClick?.(event);
  }
  const useNextLink = href != null && link && (link.type === "OPEN_PAGE" || link.type === "OPEN_URL" && isValidHref(link.payload.url));
  const isPagesRouter = useIsPagesRouter();
  if (useNextLink) {
    return /* @__PURE__ */ jsx(
      NextLink,
      {
        ...restOfProps,
        ref,
        target,
        onClick: handleClick,
        href,
        ...isPagesRouter ? { locale: false } : {},
        legacyBehavior: false
      }
    );
  }
  return /* @__PURE__ */ jsx("a", { ...restOfProps, ref, href, target, onClick: handleClick });
});
export {
  Link
};
//# sourceMappingURL=index.js.map